import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Specialite } from 'src/app/shared/models/specialite';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class SpecialiteService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllSpecialites(): Observable<Specialite[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.specialiteUrl}s`,
			'getAllSpecialites'
		);
	}

	importSpecialite(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'specialites.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.specialiteUrl}/import`,
			`importSpecialite`,
			formData
		);
	}

	getSpecialiteById(id: number): Observable<Specialite> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.specialiteUrl}/${id}`,
			'getSpecialiteById'
		);
	}

	updateSpecialite(specialite: Specialite): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.specialiteUrl}`,
			'updateSpecialite',
			specialite
		);
	}

	addSpecialite(specialite: Specialite): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.specialiteUrl}`,
			'addSpecialite',
			specialite
		);
	}

	deleteSpecialite(specialiteId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.specialiteUrl}/${specialiteId}`,
			`deleteSpecialite`
		);
	}
}
